import { ARMS } from './arms/index';

export type Arm =
  | 'control'
  | 'v1_delta_chips'
  | 'v2_plain_counts_stacked'
  | 'v3_plain_counts_inline'
  | 'v4_trend_icons';

export type ResolvedArm = Arm | undefined;

export type BarStyle = 'classic' | 'whole_bar';
export type StatStyle = 'none' | 'plain' | 'delta_chip' | 'trend_icon';
export type StatLayout = 'stacked' | 'inline';

export interface NavImpactSurfaces {
  barStyle: BarStyle;
  statStyle: StatStyle;
  statLayout: StatLayout;
}

export interface BarHeights {
  desktop: number;
  mobile: number;
}

export const CONTROL: NavImpactSurfaces = {
  barStyle: 'classic',
  statStyle: 'none',
  statLayout: 'stacked',
};

const ARM_NAMES: ReadonlySet<string> = new Set(Object.keys(ARMS));

export function resolveNavImpactStats(
  arm: string | null | undefined,
): NavImpactSurfaces {
  const spec = arm != null && ARM_NAMES.has(arm) ? ARMS[arm as Arm] : undefined;
  return { ...CONTROL, ...(spec ? spec() : {}) };
}

export function barHeightsFor(surfaces: NavImpactSurfaces): BarHeights | null {
  if (surfaces.barStyle !== 'whole_bar') {
    return null;
  }
  return {
    desktop: surfaces.statLayout === 'inline' ? 60 : 64,
    mobile: 64,
  };
}

export function impressionExtra(
  arm: string | null | undefined,
  testRunning: boolean | null | undefined,
): Record<string, unknown> {
  return {
    test_bucket: arm ?? 'control',
    ...(testRunning && { test_name: 'nav_impact_stats_2026_q3_v1' }),
  };
}
